import { createSelector } from 'reselect';

import { DashboardState } from 'store/dashboard/dashboardReducer';
import { RootState } from 'store/types';

const selectDashboardState = (state: RootState) => state.dashboard;

export const selectTradeValuationDate = createSelector(
  selectDashboardState,
  (dashboardState: DashboardState) => dashboardState.tradeValuationDate,
);
export const selectTradeValuationDateLoading = createSelector(
  selectDashboardState,
  (dashboardState: DashboardState) => dashboardState.tradeValuationDateLoading,
);
export const selectTotalValue = createSelector(
  selectDashboardState,
  (dashboardState: DashboardState) => dashboardState.totalValue,
);
export const selectTotalValueLoading = createSelector(
  selectDashboardState,
  (dashboardState: DashboardState) => dashboardState.totalValueLoading,
);

export const selectCounterPartyHedgeNotional = createSelector(
  selectDashboardState,
  (dashboardState: DashboardState) => dashboardState.counterPartyHedgeNotional,
);
export const selectCounterPartyValueLoading = createSelector(
  selectDashboardState,
  (dashboardState: DashboardState) => dashboardState.counterPartyValueLoading,
);

export const selectCounterPartyExposure = createSelector(
  selectDashboardState,
  (dashboardState: DashboardState) => dashboardState.counterPartyExposure,
);

export const selectCounterPartyExposureLoading = createSelector(
  selectDashboardState,
  (dashboardState: DashboardState) =>
    dashboardState.counterPartyExposureLoading,
);

export const selectDebtAndHedge = createSelector(
  selectDashboardState,
  (dashboardState: DashboardState) => dashboardState.debtAndHedge,
);

export const selectDebtAndHedgeLoading = createSelector(
  selectDashboardState,
  (dashboardState: DashboardState) => dashboardState.debtAndHedgeLoading,
);

export const selectHedgeTotalLoading = createSelector(
  selectDashboardState,
  (dashboardState: DashboardState) => dashboardState.hedgeTotalLoading,
);

export const selectHedgeTotal = createSelector(
  selectDashboardState,
  (dashboardState: DashboardState) => dashboardState.hedgeTotal,
);

export const selectTotalPortfolioAndSparkData = createSelector(
  selectDashboardState,
  (dashboardState: DashboardState) => dashboardState.totalPortfolioAndSparkData,
);
export const selectTotalPortfolioAndSparkDataLoading = createSelector(
  selectDashboardState,
  (dashboardState: DashboardState) =>
    dashboardState.totalPortfolioAndSparkDataLoading,
);
